import { render, staticRenderFns } from "./rAndeDetails.vue?vue&type=template&id=049037cc&scoped=true&"
import script from "./rAndeDetails.vue?vue&type=script&lang=js&"
export * from "./rAndeDetails.vue?vue&type=script&lang=js&"
import style0 from "./rAndeDetails.vue?vue&type=style&index=0&id=049037cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049037cc",
  null
  
)

export default component.exports